// extracted by mini-css-extract-plugin
module.exports = {"comparison-paper-container":"agentView_comparison-paper-container__1Cwr-"};